// extracted by mini-css-extract-plugin
export default {"stage":"styles_stage__mhap+","rotate":"styles_rotate__wuFXQ","ring":"styles_ring__hnqrr","poster":"styles_poster__nxf0f"};